import {createRouter, createWebHistory} from "vue-router";
// import Home from "./components/Home.vue";
import Login from "./components/Login.vue";
// lazy-loaded
const Settings = () => import("./components/Settings.vue")
const BoardHost = () => import("./components/Host/BoardHost.vue")
const BoardLeader = () => import("./components/Manager/BoardLeader.vue")
const NewEvent = () => import("./components/Host/NewEvent.vue")
const EventDetailHost = () => import("./components/Host/EventDetailHost.vue")
const Register = () => import("./components/Register")
const UserDetailManager = () => import("./components/Manager/UserDetailManager.vue")
const EventOverview = () => import("./components/Manager/EventOverview.vue")
const NewPWD = () => import("./components/NewPWD")
const InfoDisplay = () => import("./components/InfoDisplay")
const SuperHost = () => import("./components/Super-Host/BoardSuperHost")
const Error_403 = () => import("./components/ErrorPages/Error_403")
const Error_404 = () => import("./components/ErrorPages/Error_404")

const routes = [
    {
        path: "/",
        name: "home",
        component: BoardLeader,
    },
    {
        path: "/login",
        component: Login,
    },
    {
        path: "/settings",
        name: "settings",
        // lazy-loaded
        component: Settings,
    },
    {
        path: "/host",
        name: "host",
        // lazy-loaded
        component: BoardHost,
    },
    {
        path: "/super",
        name: "super",
        // lazy-loaded
        component: SuperHost,
    },
    {
        path: "/leader/:path",
        name: "leader",
        // lazy-loaded
        component: BoardLeader,
    },
    {
        path: "/user-details/:id",
        name: "user",
        // lazy-loaded
        component: UserDetailManager,
    },
    {
        path: "/overview/:id",
        name: "overview",
        component: EventOverview,
    },
    {
        path: "/add",
        name: "add",
        // lazy-loaded
        component: NewEvent,
    },
    {
        path: "/event/:id",
        name: "event",
        // lazy-loaded
        component: EventDetailHost,
    },
    {
        path: "/signup/:token",
        name: "Signup",
        component: Register,
    },
    {
        path: "/reset/pwd/:token",
        name: "resetPWD",
        component: NewPWD,
    },
    {
        path: "/version",
        name: "version",
        component: InfoDisplay,
    },
    {
        path: "/error_403",
        name: "Error_403",
        component: Error_403,
    },
    {
        path: "/error_404",
        name: "Error_404",
        component: Error_404,
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('user');
    const user = JSON.parse(loggedIn);

    const superHostPages = ['/super'];
    const hostPages = ['/host', "/event"];
    const leaderPages = ['/leader', '/user-details', '/overview'];

    if (authRequired && !loggedIn && !to.path.includes("/reset/pwd") && !to.path.includes("/version")) {
        if ((to.path === "/signup/" || to.path === "/signup") && !loggedIn) {
            next('/login');
        }
        if (to.path.startsWith("/signup") && !loggedIn) {
            next();
        }
        next('/login');
    } else if (to.path === "/login" && loggedIn) {
        next("/leader/own");
    } else if (to.path === "/member" && loggedIn) {
        next()
    } else if (authRequired && loggedIn) {
        let path = to.path;

        if (path.startsWith("/event")) path = "/event";
        else if (path.startsWith("/leader")) path = "/leader";
        else if (path.startsWith("/user-details")) path = "/user-details";
        else if (path.startsWith("/overview")) path = "/overview";

        if(superHostPages.includes(path) && user.roles.includes("ROLE_SUPER_HOST")){
            next()
        } else if (hostPages.includes(path) && user.roles.includes("ROLE_HOST")) {
            next()
        } else if (leaderPages.includes(path) && user.roles.includes("ROLE_TEAMLEADER")) {
            if(to.path.endsWith('/leader') || to.path.endsWith('/leader/')) next('/leader/own')
            next()
        } else if (to.path.startsWith("/error_")) {
            next()
        } else {
            if (to.path === "/settings") {
                next();
            } else {
                next("/leader/own");
            }
        }
    } else {
        next();
    }
});

export default router;